import React from 'react'
import { MySvgIcon } from './MySvgIcon'
export interface IconOpenTabProps {
  className?: string
  title?: string
  srText?: string
  focusable?: boolean
}

export const IconOpenTab:React.FC<IconOpenTabProps> = ({ srText, ...props }) => {
  return (
    <>
    <MySvgIcon width='18px' viewBox='0 0 18 16' version='1.1' {...props}>
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g transform='translate(0.000000, -1.000000)' fill='#1E3C70' fillRule='nonzero'>
          <g transform='translate(0.000000, 1.000000)'>
            <path d='M18,0.75 L18,4.7495 C18,5.42015625 17.18875,5.748875 16.7196562,5.27984375 L15.6038125,4.1639375 L7.99371875,11.7740313 C7.7008125,12.0669375 7.22596875,12.0669375 6.9330625,11.7740313 L6.22596875,11.0669375 C5.9330625,10.7740313 5.9330625,10.2991562 6.22596875,10.0062813 L13.836125,2.396125 L12.7204062,1.28034375 C12.2494375,0.809375 12.583,0 13.25075,0 L17.25,0 C17.6642187,0 18,0.33578125 18,0.75 Z M12.7196562,8.4623125 L12.2196562,8.9623125 C12.0790027,9.10296842 11.9999893,9.29374043 12,9.49265625 L12,14 L2,14 L2,4 L10.25,4 C10.4489023,3.99998866 10.6396565,3.92097798 10.7803125,3.78034375 L11.2803125,3.28034375 C11.7527812,2.80784375 11.4181562,2 10.75,2 L1.5,2 C0.6715625,2 0,2.6715625 0,3.5 L0,14.5 C0,15.3284375 0.6715625,16 1.5,16 L12.5,16 C13.3284375,16 14,15.3284375 14,14.5 L14,8.992625 C14,8.3244375 13.192125,7.9898125 12.7196562,8.4623125 Z' />
          </g>
        </g>
      </g>
    </MySvgIcon>
    {srText && <span data-testid="sr-only" className="ds-u-visibility--screen-reader">{srText}</span>}
    </>
  )
}
